import { ModelBase } from "../shared/model.base";

export class Grupo extends ModelBase {
    id_user: number;
    id_company: number;
    group_type: string;
    operator_id: number;
    userId: number;
    operatorId: number;
    companyId: number;
    name: string;
    status: number;
    memberCount: number;
    deleteDuplicates: boolean;

    constructor() {
        super();

        this.name = "";
        this.status = 1;
        this.memberCount = null;
        this.group_type = "PRV";
        this.id_user = null;
        this.operator_id = null;
        this.deleteDuplicates = false;
    }
}
